import { Card, Row, Col, Statistic } from 'antd';
import { LinkOutlined, EyeOutlined, CheckCircleOutlined, CalendarOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import api from '../utils/api';
import type { OverviewStats } from '../types';

export default function Dashboard() {
  const [stats, setStats] = useState<OverviewStats | null>(null);

  useEffect(() => {
    api.get('stats/overview').json<{ success: boolean; data: OverviewStats }>().then((res) => {
      if (res.success && res.data) {
        setStats(res.data);
      }
    });
  }, []);

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>仪表盘</h2>
      <Row gutter={16}>
        <Col span={6}>
          <Card>
            <Statistic
              title="总链接数"
              value={stats?.totalLinks ?? 0}
              prefix={<LinkOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="活跃链接"
              value={stats?.activeLinks ?? 0}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="总访问量"
              value={stats?.totalVisits ?? 0}
              prefix={<EyeOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="今日访问"
              value={stats?.todayVisits ?? 0}
              prefix={<CalendarOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
